import {DomainEvent} from './DomainEvent';
import {ProfilePlayerSeasonBan} from '../resources/ProfilePlayerSeasonBan';

export class ProfileSeasonBanCreated extends DomainEvent<ProfilePlayerSeasonBan> {}
